import config from '../../config';

/**
 * Checks if the 'window.location.host' is 'localhost:3003'
 * @type {boolean}
 */
export const isDeveloperMode = window.location.host === `localhost:${config.browsersync.port}`;
